import React from "react";
import { Edit } from "react-admin";
import { EditActions } from "../../common/form/FormActions";
import { DriverForm } from "./DriverForm";
import { useNotification } from "../../../common/hooks/useNotification";
import { useFieldPermissions } from "../../../common/hooks/useFieldPermissions";
import { protectedEntities } from "../../../common/auth/permissions";
import { FieldPermissionsContext } from "../../common/field-permissions/FieldPermissionsContext";

interface IDriverCreateProps {}

export const DriverEdit = (props: IDriverCreateProps) => {
  const notify = useNotification(props, "editSuccess");
  const fieldPermissions = useFieldPermissions(
    protectedEntities.Driver,
    (x) => x.edit
  );
  return (
    <FieldPermissionsContext.Provider value={fieldPermissions}>
      <Edit
        {...props}
        actions={<EditActions />}
        onSuccess={notify}
        mutationMode="pessimistic"
        transform={(data) => ({
          ...data,
          driverName: data.name + " " + data.surname,
        })}
        title="resources.admin-drivers.title.edit">
        <DriverForm isEdit />
      </Edit>
    </FieldPermissionsContext.Provider>
  );
};
